export default __webpack_public_path__ + "static/Dreadlocks-e8ae60dd35e34adf73e4fdc008380149.png";